import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../core/store";
import { AsyncActionStatus } from "../../../core/types/store";
import { EProductReservationMethods } from "../../types";
import * as useSecurityStore from './useSecurityStore';

const useSecurity = () => {
    const dispatch = useAppDispatch();
    const security = useAppSelector(useSecurityStore.selectors.getSecurity);
    const methods = useAppSelector(useSecurityStore.selectors.getMethods);
    const isLoaded = useAppSelector(useSecurityStore.selectors.getIsLoaded);
    useEffect(() => {
        const isReadyToSetRoles = security.status === AsyncActionStatus.succeeded
        if (isReadyToSetRoles) {
            dispatch(useSecurityStore.actionsSecurity.setMethods());
        }

    }, [dispatch, security.status, isLoaded]);

    const canManage = () => {
        return methods?.includes(String(EProductReservationMethods.Manage));
    };

    const canView = () => {
        return methods?.includes(String(EProductReservationMethods.View));
    };
    const isPageAuthorized = () => {
        const acceptedMethods = [String(EProductReservationMethods.View)];
        for (let index = 0; index < methods!.length; index++) {
            if (acceptedMethods.includes(methods![index])) {
                return true;
            }
        }
        return false;
    };

    return { canManage, canView, isPageAuthorized, isLoaded };
};

export default useSecurity;